import React, { useCallback, useState } from 'react';

import { useCreate } from '../hooks';

import {
  ButtonBar, ErrorMessage, Input, ModalFormHeader 
} from '.';

interface NewPersonFormProps {
  handleCancel?: () => void;
  handleSaveCompletion?: () => void;
  inModal?: boolean;
}

export function NewPersonForm({ 
  handleCancel,
  handleSaveCompletion, 
  inModal 
}: NewPersonFormProps) {
  const { handleCreate } = useCreate('people');

  const [ error, setError ] = useState('');

  const handleSave = useCallback(async () => {
    const payload = {} as Record<string, string>;

    payload.first_name = (document.getElementById('first-name') as HTMLInputElement).value;
    payload.middle_name = (document.getElementById('middle-name') as HTMLInputElement).value;
    payload.last_name = (document.getElementById('last-name') as HTMLInputElement).value;
    payload.contact_email = (document.getElementById('email') as HTMLInputElement).value;
    payload.contact_phone = (document.getElementById('phone-number') as HTMLInputElement).value;

    if (!payload.contact_email && !payload.contact_phone) {
      return setError('Must fill out email or phone number');
    }

    await handleCreate(payload);

    if (handleSaveCompletion) {
      handleSaveCompletion();
    }
  }, [ handleCreate, handleSaveCompletion ]);

  const classes = [ 'new-beneficiary-form' ];

  if (inModal) {
    classes.push('modal-form-container');
  } else {
    classes.push('form-container');
  }

  return (
    <div className={classes.join(' ')}>
      <ModalFormHeader
        icon="group_add"
        header="Add a new person"
      />
      <Input id="first-name" label="First Name" required />
      <Input id="middle-name" label="Middle Name" />
      <Input id="last-name" label="Last Name" required />
      <p>Must fill out email or phone number</p>
      <Input id="email" label="Email" />
      <Input id="phone-number" label="Phone Number" />
      <ErrorMessage message={error} />
      <ButtonBar
        handlePrimary={handleSave}
        primaryText="Save"
        handleSecondary={handleCancel}
        secondaryText="Cancel"
      />
    </div>
  );
}
